export { default as useReadLocalStorage } from './useReadLocalStorage';
export * from './useReadLocalStorage';
//# sourceMappingURL=index.js.map